import React from 'react';
import { Card, CardContent, Typography, Avatar, Box, Rating } from '@mui/material';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';

const TestimonialCard = ({ name, role, quote, rating, avatarUrl }) => {
  return (
    <Card sx={{ 
      height: '100%',
      background: 'linear-gradient(to bottom, #ffffff, #f9fafb)',
      position: 'relative',
      overflow: 'visible'
    }}>
      <CardContent sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        height: '100%', 
        paddingTop: '3rem',
        padding: 'var(--space-lg)'
      }}>
        <Box sx={{ 
          position: 'absolute',
          top: '-25px',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: '#fff',
          borderRadius: '50%',
          padding: '5px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
        }}>
          <Avatar 
            src={avatarUrl} 
            alt={name}
            sx={{ 
              width: 70, 
              height: 70,
              border: '3px solid white'
            }}
          />
        </Box>
        
        <Box sx={{ 
          position: 'absolute',
          top: 'var(--space-sm)',
          right: 'var(--space-sm)',
          color: 'var(--color-primary)',
          opacity: 0.2
        }}>
          <FormatQuoteIcon fontSize="large" />
        </Box>
        
        <Box sx={{ marginTop: 'var(--space-lg)', textAlign: 'center' }}>
          <Typography variant="h6" sx={{ fontWeight: 600, marginBottom: '4px' }}>{name}</Typography>
          <Typography variant="body2" sx={{ color: 'var(--color-text-light)', marginBottom: 'var(--space-sm)' }}>{role}</Typography>
        </Box>
        
        <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: 'var(--space-md)' }}>
          <Rating value={rating} readOnly precision={0.5} size="small" />
        </Box>
        
        <Typography variant="body2" sx={{ 
          textAlign: 'center', 
          fontStyle: 'italic', 
          flexGrow: 1,
          lineHeight: 1.7,
          color: 'var(--color-text)'
        }}>
          "{quote}"
        </Typography>
      </CardContent>
    </Card>
  );
};

export default TestimonialCard;